<template>
  <v-row justify="center">
    <v-dialog
      :value="active"
      @click:outside="closeDialog"
      scrollable
      max-width="500"
    >
      <ValidationObserver ref="obs" v-slot="{ passes }">
        <v-card>
          <v-card-title class="pa-0 shadow-1">
            <v-img
              :src="require('@/assets/illustrations/bg_modal_card.svg')"
              cover
              position="left bottom"
              class="align-center"
              height="65px"
            >
              <v-card-title class="font-weight-medium primary--text">
                {{ isEdit ? "Actualizar pausa" : "  Nueva pausa" }}
              </v-card-title>
            </v-img>
          </v-card-title>

          <vuescroll
            :ops="{
              bar: { background: '#bacfcec0', keepShow: true },
            }"
          >
            <v-card-text style="max-height: 350px">
              <v-form>
                <v-row dense>
                  <v-col cols="12">
                    <ValidationProvider
                      name="nombre"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Nombre"
                        name="nombre"
                        type="text"
                        color="blue-grey"
                        v-model="formData.name"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12" md="5">
                    <ValidationProvider
                      name="cantidad"
                      rules="required|numeric"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Cantidad"
                        name="cantidad"
                        prepend-inner-icon="mdi-bell"
                        color="blue-grey"
                        v-model="formData.quantity"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12" md="7">
                    <ValidationProvider
                      name="duración"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-dialog
                        ref="dialog"
                        v-model="modalTimePicker"
                        :return-value.sync="formData.time"
                        persistent
                        width="320px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            readonly
                            v-on="on"
                            v-bind="attrs"
                            required
                            filled
                            rounded
                            class="rounded-small"
                            dense
                            label="Duración"
                            name="tiempo"
                            prepend-inner-icon="mdi-clock-time-seven"
                            color="blue-grey"
                            v-model="formData.time"
                            :error-messages="errors"
                          ></v-text-field>
                        </template>
                        <v-time-picker
                          v-if="modalTimePicker"
                          v-model="formData.time"
                          full-width
                          use-seconds
                          format="24hr"
                        >
                          <v-spacer></v-spacer>
                          <v-hover v-slot:default="{ hover }">
                            <v-btn
                              text
                              rounded
                              class="mr-1"
                              :color="hover ? 'error' : 'grey'"
                              @click="modalTimePicker = false"
                            >
                              Cancelar
                            </v-btn>
                          </v-hover>

                          <v-hover v-slot:default="{ hover }">
                            <v-btn
                              rounded
                              color="success"
                              :class="hover ? 'shadow-2' : 'shadow-4'"
                              class="px-8"
                              @click="$refs.dialog.save(formData.time)"
                            >
                              Ok
                            </v-btn>
                          </v-hover>
                        </v-time-picker>
                      </v-dialog>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12" md="5">
                    <v-switch
                      class="ml-3"
                      v-model="formData.is_documentation"
                      inset
                      :label="
                        formData.is_documentation ? 'Documentación' : 'Normal'
                      "
                    ></v-switch>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </vuescroll>

          <v-divider></v-divider>

          <v-card-actions class="mx-2">
            <v-spacer></v-spacer>
            <v-hover v-slot:default="{ hover }">
              <v-btn
                text
                rounded
                class="mr-1"
                :color="hover ? 'error' : 'grey'"
                @click="closeDialog"
              >
                Cancelar
              </v-btn>
            </v-hover>

            <v-hover v-slot:default="{ hover }">
              <v-btn
                rounded
                :loading="loading"
                :disabled="loading"
                color="success"
                :class="hover ? 'shadow-2' : 'shadow-4'"
                class="px-8"
                @click="passes(submitForm)"
              >
                {{ isEdit ? "Actualizar" : "Añadir" }}
              </v-btn>
            </v-hover>
          </v-card-actions>
        </v-card>
      </ValidationObserver>
    </v-dialog>
  </v-row>
</template>

<script>
import vuescroll from "vuescroll";
export default {
  components: { vuescroll },
  props: {
    active: { type: Boolean },
    data: { type: Object, default: () => ({}) },
    isEdit: { type: Boolean },
  },
  data() {
    return {
      modalTimePicker: false,
      loading: false,
      formData: {
        name: "",
        quantity: "",
        time: "",
        is_documentation: false,
      },
    };
  },

  watch: {
    isEdit(val) {
      if (val)
        this.formData = {
          name: this.data.name,
          quantity: this.data.quantity,
          time: this.data.time,
          is_documentation: this.data.is_documentation,
        };
    },
  },

  methods: {
    resetForm() {
      this.$refs.obs.reset();
      this.formData = {
        name: "",
        quantity: "",
        time: "",
        is_documentation: false,
      };
    },

    closeDialog() {
      this.resetForm();
      this.$emit("dialog:close");
    },

    async submitForm() {
      try {
        this.loading = true;
        if (this.isEdit) {
          const payload = { data: this.formData, id: this.data.id };
          await this.$store.dispatch("breaks/EDIT_BREAKS", payload);
          this.$snotify.success("Pausa actualizada con éxito.", "¡Hecho!");
        } else {
          await this.$store.dispatch("breaks/REGISTER_BREAKS", this.formData);
          this.$snotify.success("Pausa creada con éxito.", "¡Hecho!");
        }

        this.closeDialog();
      } catch (error) {
        this.$snotify.error(error.response.data, "Error");
      }
      this.loading = false;
    },
  },
};
</script>
